document.addEventListener("DOMContentLoaded", () => {
  // =============================================
  // 1. STATE MANAGEMENT
  // =============================================
  const state = {
    uploadedImage1: null,
    uploadedImage2: null,
    editedImage: null,
    artworkImage: null,
    size: "4'x1'", // Default size
    design_notes: null,
    packaging_type: "Folded in a Box",
    grommet_color: "Silver",
    extra_grommets: "No",
    premium_backgrounds: "None",
    font_color1: "Black",
    font_color2: "Black",
    font1: "Anton",
    font2: "Anton",
    text1: "",
    text2: "",
    color: "None",
    mainColor: "Standard",
    price: 0,
  };
  // Single instance of BannerDesigner
  let designer = null;
  // =============================================
  // 2. PRICE VARIANTS
  // =============================================
  const PRICE_VARIANTS = {
    size: [
      { value: "4'x1'", price: 0.0 },
      { value: "5'x1'", price: 7.0 },
      { value: "6'x1'", price: 10.0 },
      { value: "7'x1'", price: 12.0 },
      { value: "8'x1'", price: 13.0 },
      { value: "2'x2'", price: 2.0 },
      { value: "3'x2'", price: 8.0 },
      { value: "4'x2'", price: 9.0 },
      { value: "5'x2'", price: 12.0 },
      { value: "6'x2'", price: 16.0 },
      { value: "7'x2'", price: 20.0 },
      { value: "8'x2'", price: 24.0 },
      { value: "9'x2'", price: 33.0 },
      { value: "10'x2'", price: 36.0 },
      { value: "12'x2'", price: 40.0 },
      { value: "16'x2'", price: 57.0 },
      { value: "3'x3'", price: 10.0 },
      { value: "5'x3'", price: 25.0 },
      { value: "6'x3'", price: 30.0 },
      { value: "7'x3'", price: 39.0 },
      { value: "8'x3'", price: 42.0 },
      { value: "9'x3'", price: 48.0 },
      { value: "10'x3'", price: 56.0 },
      { value: "12'x3'", price: 70.0 },
      { value: "15'x3'", price: 85.0 },
      { value: "4'x4'", price: 24.0 },
      { value: "5'x4'", price: 32.0 },
      { value: "6'x4'", price: 41.0 },
      { value: "7'x4'", price: 53.0 },
      { value: "8'x4'", price: 60.0 },
      { value: "9'x4'", price: 68.0 },
      { value: "10'x4'", price: 80.0 },
      { value: "12'x4'", price: 92.0 },
      { value: "15'x4'", price: 114.0 },
      { value: "4'x20'", price: 144.0 },
    ],
    mainColor: [
      { value: "Standard", price: 22.99 },
      { value: "Premium", price: 24.99 },
    ],
    premium_backgrounds: [
      { value: "None", price: 0.0 },
      { value: "Spilled Ink 1", price: 1.0 },
      { value: "Spilled Ink 2", price: 1.0 },
      { value: "Green Parchment", price: 1.0 },
      { value: "Green Streaks", price: 1.0 },
      { value: "Purple Gemstones", price: 1.0 },
      { value: "Triangles", price: 1.0 },
      { value: "Fern Leaves", price: 1.0 },
      { value: "Colorful Blur", price: 1.0 },
      { value: "Brown Blur", price: 1.0 },
      { value: "Old Parchment", price: 1.0 },
      { value: "Bokeh 1", price: 1.0 },
      { value: "Bokeh 2", price: 1.0 },
      { value: "Clouds", price: 1.0 },
      { value: "Pink Clouds", price: 1.0 },
      { value: "Purple Paint Strokes", price: 1.0 },
      { value: "Blue Paint Strokes", price: 1.0 },
      { value: "Pink/Blue Watercolor", price: 1.0 },
      { value: "Orange Paint", price: 1.0 },
      { value: "Night Sky", price: 1.0 },
      { value: "Galaxy Painting", price: 1.0 },
      { value: "Red Glitter", price: 1.0 },
      { value: "Water", price: 1.0 },
      { value: "Black/White Stripes", price: 1.0 },
      { value: "White/Gray Swish", price: 1.0 },
    ],
    grommet_color: [
      { value: "Silver", price: 0.0 },
      { value: "Gold", price: 2.0 },
      { value: "Black", price: 3.0 },
    ],
    packaging_type: [
      { value: "Folded in a Box", price: 0.0 },
      { value: "Rolled in a Tube (NO WRINKLES)", price: 25.0 },
    ],
    extra_grommets: [
      { value: "No", price: 0.0 },
      { value: "Yes", price: 10.0 },
    ],
  };

  const FORMAT_ICONS = {
    pdf: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/pdf-file.png",
    ai: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/ai-file.png",
    eps: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/eps-file.png",
    tiff: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/tif-file.png",
  };

  const NON_EDITABLE_EXTS = ["pdf","ai","eps","tiff","psd"];

  // Premium backgrounds URLs (using placeholders; replace with actual)
  const PREMIUM_BACKGROUND_URLS = {
    "Spilled Ink 1":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/spilled-ink-1.png",
    "Spilled Ink 2":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/spilled-ink-2.png",
    "Green Parchment":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/green-parchment.png",
    "Green Streaks":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/green-streaks.png",
    "Purple Gemstones":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/purple-gemstone.png",
    Triangles:
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/triangles.png",
    "Fern Leaves":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/fern-leaves.png",
    "Colorful Blur":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/colorful-blur.png",
    "Brown Blur":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/brown-blur.png",
    "Old Parchment":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/old-parchment.png",
    "Bokeh 1":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/bokeh-1.png",
    "Bokeh 2":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/bokeh-2.png",
    Clouds: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/clouds.png",
    "Pink Clouds":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/pink-clouds.png",
    "Purple Paint Strokes":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/purple-paint-strokes.png",
    "Blue Paint Strokes":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/blue-paint-strokes.png",
    "Pink/Blue Watercolor":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/pink-blue-watercolor.png",
    "Orange Paint":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/orange-paint.png",
    "Night Sky":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/night-sky.png",
    "Galaxy Painting":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/galaxy-painting.png",
    "Red Glitter":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/red-glitter.png",
    Water: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/water.png",
    "Black/White Stripes":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/black-white-stripes.png",
    "White/Gray Swish":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/white-gray-swish.png",
  };
  // Color mappings for background colors
  const COLOR_MAPPINGS = {
    None: "transparent",
    Black: "#000000",
    White: "#ffffff",
    Red: "#ff0003",
    "Ruby Red": "#9b111e",
    Orange: "#ff7b00",
    Yellow: "#fedc00",
    Green: "#00ff07",
    "Grass Green": "#008103",
    Blue: "#0022ff",
    "Sky Blue": "#00b7ff",
    Purple: "#8800ff",
    Magenta: "#ff00e1",
    Pink: "#ffa9cb",
  };
  const FONT_COLORS = {
    None: "transparent",
    Black: "#000000",
    White: "#ffffff",
    "Dark Gray": "#545454",
    Gray: "#737373",
    "Light Gray": "#d9d9d9",
    Red: "#ff0000",
    "Coral Red": "#ff5757",
    Pink: "#ff66c4",
    Magenta: "#cb6ce6",
    Purple: "#8c52ff",
    Violet: "#5e17eb",
    Turquoise: "#0097b2",
    "Light Blue": "#38b6ff",
    "Cobalt Blue": "#004aad",
    Navy: "#224092",
    Green: "#00bf63",
    "Grass Green": "#7ed957",
    Yellow: "#ffde59",
    Peach: "#ffbd59",
    Orange: "#ff914d",
    Brown: "#743c18",
  };
  // =============================================
  // 3. HELPER FUNCTIONS
  // =============================================
  function show(el) {
    if (el) el.style.display = "";
  }
  function hide(el) {
    if (el) el.style.display = "none";
  }
  function animatePriceChange(targetElement, start, end, duration = 500) {
    let startTime = null;
    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const currentValue = start + (end - start) * progress;
      targetElement.textContent = currentValue.toFixed(2);
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function priceOf(groupKey, chosenValue) {
    if (!chosenValue) return 0;
    const list = PRICE_VARIANTS[groupKey] || [];
    const found = list.find((item) => item.value === chosenValue);
    return found ? found.price : 0;
  }
  function debounce(func, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  }
  function dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }
  const downloadEditedImage = (file) => {
    const url = URL.createObjectURL(file);
    const a = document.createElement("a");
    a.href = url;
    a.download = file.name || "edited-banner.png";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };
  function disableBodyScroll() {
    const scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.dataset.scrollY = scrollY; // save position
  }

  function enableBodyScroll() {
    const scrollY = document.body.dataset.scrollY || 0;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, parseInt(scrollY, 10));
    document.body.removeAttribute('data-scrollY');
  }

  function hasRequiredArtworkForCart() {
    return Boolean(state.artworkImage || state.editedImage);
  }

  function updateAddToCartAvailability() {
    const addToCartBtn = document.getElementById("pcvb-add-to-cart");
    if (!addToCartBtn) return;
    const canAddToCart = hasRequiredArtworkForCart();
    addToCartBtn.disabled =
      !canAddToCart || addToCartBtn.classList.contains("loading");
    addToCartBtn.classList.toggle("pcvb-cart-btn--locked", !canAddToCart);
    addToCartBtn.setAttribute("aria-disabled", String(!canAddToCart));
    addToCartBtn.title = canAddToCart
      ? ""
      : "Design online or upload artwork before adding to cart.";
  }

  function parseBannerSizeFeet(sizeStr = state.size) {
    const fallback = { widthFeet: 4, heightFeet: 1 };
    if (!sizeStr) return fallback;
    const parts = String(sizeStr)
      .replace(/'/g, "")
      .split("x")
      .map((val) => parseFloat(val.trim()));
    if (!parts[0] || !parts[1]) return fallback;
    return { widthFeet: parts[0], heightFeet: parts[1] };
  }

  function updatePreviewSizeDisplay(sizeStr = state.size) {
    const { widthFeet, heightFeet } = parseBannerSizeFeet(sizeStr);
    const widthLabel = document.getElementById("width-inch");
    const heightLabel = document.getElementById("height-inch");
    const previewFrame = document.querySelector("#preview-box .pcvb-banner-preview");

    if (widthLabel) widthLabel.textContent = `${widthFeet}'`;
    if (heightLabel) heightLabel.textContent = `${heightFeet}'`;
    if (previewFrame) {
      const ratio = widthFeet / heightFeet;
      const maxWidth = 280;
      const maxHeight = 220;
      let frameWidth = maxWidth;
      let frameHeight = frameWidth / ratio;
      if (frameHeight > maxHeight) {
        frameHeight = maxHeight;
        frameWidth = frameHeight * ratio;
      }
      previewFrame.style.setProperty(
        "--pcvb-preview-aspect",
        `${widthFeet} / ${heightFeet}`
      );
      previewFrame.style.setProperty(
        "--pcvb-preview-width",
        `${Math.round(frameWidth)}px`
      );
      previewFrame.dataset.size = `${widthFeet}x${heightFeet}`;
    }
  }

  // =============================================
  // 4. SIZE SELECTOR SYNCHRONIZATION
  // =============================================
  function setupSizeSelectorSynchronization() {
    const sidebarSelector = document.getElementById("size-select");
    const mainSelector = document.getElementById("size-select-main");

    if (!sidebarSelector || !mainSelector) return;

    // Sync from sidebar to main
    sidebarSelector.addEventListener("change", (e) => {
      if (e.target.value) {
        const option = sidebarSelector.querySelector(`li[data-value="${e.target.value}"]`);
        if (option) {
          syncSizeSelectors(e.target.value, option.textContent);
        }
      }
    });

    // Sync from main to sidebar once artwork or an online design exists.
    mainSelector.addEventListener("change", (e) => {
      if (e.target.value && hasRequiredArtworkForCart()) {
        const option = mainSelector.querySelector(`li[data-value="${e.target.value}"]`);
        if (option) {
          syncSizeSelectors(e.target.value, option.textContent);
          const sidebarEvent = new Event("change");
          sidebarEvent.target = { value: e.target.value };
          sidebarSelector.dispatchEvent(sidebarEvent);
        }
      }
    });

    // Handle click events on both dropdowns
    function setupDropdownSync(dropdown, counterpart) {
      dropdown.addEventListener("click", (e) => {
        const optionEl = e.target.closest("li[data-value]");
        if (optionEl) {
          const value = optionEl.dataset.value;
          const text = optionEl.textContent;
          syncSizeSelectors(value, text);

          // Update state and trigger price recalculation
          state.size = value;
          updatePreviewSizeDisplay(value);
          recalcPrice();

          // Update designer if it exists
          if (designer) {
            designer.updateSize(value);
          }
        }
      });
    }

    setupDropdownSync(sidebarSelector, mainSelector);
    setupDropdownSync(mainSelector, sidebarSelector);
  }

  // Update syncSizeSelectors to control active class explicitly
  function syncSizeSelectors(value, text) {
    const sidebarSelector = document.getElementById("size-select");
    const mainSelector = document.getElementById("size-select-main");
    const sizeSelectMain = document.getElementById("size-select-variant-main");

    console.log("syncSizeSelectors called, state.artworkImage:", state.artworkImage);
    updatePreviewSizeDisplay(value);

    if (sidebarSelector) {
      const sidebarHeader = sidebarSelector.querySelector(".selected-text");
      if (sidebarHeader) sidebarHeader.textContent = text;
      sidebarSelector.querySelectorAll("li").forEach(li => {
        li.classList.toggle("selected", li.dataset.value === value);
      });
      sidebarSelector.classList.add("variant-picked");
    }

    if (mainSelector && hasRequiredArtworkForCart()) {
      const mainHeader = mainSelector.querySelector(".selected-text");
      if (mainHeader) mainHeader.textContent = text;
      mainSelector.querySelectorAll("li").forEach(li => {
        li.classList.toggle("selected", li.dataset.value === value);
      });
      mainSelector.classList.add("variant-picked");
      if (sizeSelectMain) {
        sizeSelectMain.classList.add("active");
        console.log("Added active class to size-select-variant-main in syncSizeSelectors");
      }
    } else if (sizeSelectMain) {
      sizeSelectMain.classList.remove("active");
      console.log("Removed active class from size-select-variant-main in syncSizeSelectors");
    }
  }

  // =============================================
  // 5. IMAGE UPLOAD HANDLING
  // =============================================
  const isDisplayableImage = (file) => {
    const ext = (file.name.split(".").pop() || "").toLowerCase();
    // Treat TIFF (image/tiff) as non-editable even though it's an image/*
    return NON_EDITABLE_EXTS.includes(ext) || file.type === "application/pdf";
  };

  function setupImageUpload(
    imageInputId,
    previewBoxId,
    previewImageId,
    errorId,
    stateKey
  ) {
    const fileInput = document.getElementById(imageInputId);
    const chooseFileBtn = document.getElementById(
      `choose-file-btn${imageInputId.slice(-1) || ""}`
    );
    const artbox = document.getElementById(
      `upload-artbox${imageInputId.slice(-1) || ""}`
    );
    const previewBox = document.getElementById(previewBoxId);
    const deleteImage = document.getElementById(
      `delete-image${imageInputId.slice(-1) || ""}`
    );
    const errorMessage = document.getElementById(errorId);
    if (
      !fileInput ||
      !chooseFileBtn ||
      !artbox ||
      !previewBox ||
      !deleteImage ||
      !errorMessage
    )
      return;
    const freshChooseBtn = chooseFileBtn.cloneNode(true);
    const freshFileInput = fileInput.cloneNode(true);
    chooseFileBtn.replaceWith(freshChooseBtn);
    fileInput.replaceWith(freshFileInput);
    freshChooseBtn.addEventListener("click", (e) => {
      e.preventDefault();
      freshFileInput.click();
    });
    freshFileInput.addEventListener("change", function (e) {
      const file = e.target.files[0];
      if (!file) {
        if (designer && designer[stateKey]) {
          designer.canvas.remove(designer[stateKey]);
          designer[stateKey] = null;
          designer.canvas.renderAll();
        }
        return;
      }
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/svg+xml"];
      if (!allowedTypes.includes(file.type)) {
        errorMessage.textContent =
          "Please upload a valid image file (.jpg, .jpeg, .png, .webp, .svg)";
        errorMessage.classList.add("active");
        freshFileInput.value = "";
        state[stateKey] = null;
        return;
      }
      const reader = new FileReader();
      reader.onload = function (e) {
        const img = document.getElementById(previewImageId);
        img.src = e.target.result;
        img.onload = function () {
          artbox.style.display = "none";
          previewBox.style.display = "block";
          errorMessage.classList.remove("active");
          state[stateKey] = file;
          if (stateKey === "uploadedImage1") {
            designer.handleImageUpload1({ target: { files: [file] } });
          } else if (stateKey === "uploadedImage2") {
            designer.handleImageUpload2({ target: { files: [file] } });
          }
        };
      };
      reader.onerror = function () {
        errorMessage.textContent = "Error reading file. Please try again.";
        errorMessage.classList.add("active");
        state[stateKey] = null;
      };
      reader.readAsDataURL(file);
    });
     
    deleteImage.addEventListener("click", function () {
      freshFileInput.value = "";
      artbox.style.display = "block";
      previewBox.style.display = "none";
      errorMessage.classList.remove("active");
      state[stateKey] = null;
      const previewImg = document.getElementById(previewImageId);
      if (previewImg) previewImg.src = "";
      if (stateKey === "uploadedImage1" && designer.uploadedImage1) {
        designer.canvas.remove(designer.uploadedImage1);
        designer.uploadedImage1 = null;
        designer.canvas.renderAll();
      } else if (stateKey === "uploadedImage2" && designer.uploadedImage2) {
        designer.canvas.remove(designer.uploadedImage2);
        designer.uploadedImage2 = null;
        designer.canvas.renderAll();
      }
    });
  }

  function setupArtworkUpload() {
    const uploadArtwork = document.getElementById("upload-artwork");
    const errorMessage = document.getElementById("upload-artwork-error");
    const artbox = document.getElementById("upload-artbox");
    const previewBox = document.getElementById("preview-box");
    const mainVariants = document.getElementById("main-variants");
    const sizeSelectMain = document.getElementById("size-select-variant-main");
    const btnEditImage = document.getElementById("btnEditImage");

    if (!uploadArtwork || !errorMessage || !artbox || !previewBox || !mainVariants || !sizeSelectMain) {
      console.error("Required elements for artwork upload are missing");
      return;
    }

    // Clear the input to ensure a fresh state
    uploadArtwork.value = "";

    uploadArtwork.addEventListener("change", (e) => {
      const file = e.target.files[0];
      if (!file) {
        console.log("No file selected");
        return;
      }

      console.log("Selected File: ", file); // Log to verify file selection

      if (isDisplayableImage(file)) {
        const img = document.getElementById("preview-image");
        img.onload = null;
        img.onerror = null;
        const ext = file.name.split(".").pop().toLowerCase();
        const iconSrc = FORMAT_ICONS[ext];

        img.src = iconSrc;
        previewBox.classList.add("non-editable-image");
        artbox.style.display = "none";
        btnEditImage.style.display = "none";
        previewBox.style.display = "block";
        mainVariants.classList.add("active");
        sizeSelectMain.classList.add("active");
        errorMessage.classList.remove("active");
        state.artworkImage = file;
        updateAddToCartAvailability();

        console.log("Upload File (non-editable): ", state.artworkImage);

        updatePreviewSizeDisplay();

        return;
      }

      const reader = new FileReader();
      reader.onload = function (e) {
        const img = document.getElementById("preview-image");
        img.src = e.target.result;
        img.onload = function () {
          artbox.style.display = "none";
          previewBox.style.display = "block";
          mainVariants.classList.add("active");
          // sizeSelectMain.classList.add("active");
          errorMessage.classList.remove("active");
          state.artworkImage = file;
          updateAddToCartAvailability();
          console.log("Upload File (editable): ", state.artworkImage);

          updatePreviewSizeDisplay();
        };
      };
      reader.onerror = function () {
        errorMessage.textContent = "Error reading file. Please try again.";
        errorMessage.classList.add("active");
        state.artworkImage = null;
        updateAddToCartAvailability();
        console.log("Upload File Error: ", state.artworkImage);
      };
      reader.readAsDataURL(file);
      sizeSelectMain.classList.add("active");
      btnEditImage.style.display = "none";
    });
  }

  // =============================================
  // 6. DROPDOWN HANDLING
  // =============================================
  function initDropdownDefaults() {
    document.querySelectorAll(".select-dropdown").forEach((dd) => {
      const preSel = dd.querySelector("li.selected");
      const header = dd.querySelector(".selected-text");
      if (preSel && header) {
        header.textContent = preSel.textContent;
        const stateKey = dd.dataset.stateKey;
        if (stateKey && preSel.dataset.value) {
          state[stateKey] = preSel.dataset.value;
        }
      }
    });
  }
  function dropdownClickHandler(evt) {
    const dropdown = evt.target.closest(".select-dropdown");
    if (!dropdown) {
      document
        .querySelectorAll(".dropdown-options")
        .forEach((list) => hide(list));
      return;
    }
    const list = dropdown.querySelector(".dropdown-options");
    const header = dropdown.querySelector(".selected-text");
    const stateKey = dropdown.dataset.stateKey;
    const optionEl = evt.target.closest("li[data-value]");
    document.querySelectorAll(".dropdown-options").forEach((other) => {
      if (other !== list) hide(other);
    });
    if (optionEl) {
      const value = optionEl.dataset.value;
      if (!value) return;
      list
        .querySelectorAll("li")
        .forEach((li) => li.classList.remove("selected"));
      optionEl.classList.add("selected");
      header.textContent = optionEl.textContent;
      dropdown.classList.add("variant-picked");
      // Handle size selector synchronization
          if (stateKey === "size") {
            syncSizeSelectors(value, optionEl.textContent);
            updatePreviewSizeDisplay(value);
          }

      // Apply font class to selected-text if it's a font dropdown
      if (header) {
        // Remove existing font- classes
        header.classList.forEach((cls) => {
          if (cls.startsWith('font-')) header.classList.remove(cls);
        });
        // Add the new font- class from the selected li
        optionEl.classList.forEach((cls) => {
          if (cls.startsWith('font-')) header.classList.add(cls);
        });
      }
      if (stateKey) {
        state[stateKey] = value;
        const targetElement = document.getElementById(`${stateKey}-select`);
        if (targetElement) {
          const customEvent = new Event("change");
          customEvent.target = { value: value };
          targetElement.dispatchEvent(customEvent);
        }
        switch (stateKey) {
          case "color":
            designer.updateBackgroundColor(value);
            break;
          case "premium_backgrounds":
            designer.updatePremiumBackground(value);
            break;
          case "size":
            designer.updateSize(value);
            break;
          case "font1":
            designer.updateFont1(value);
            break;
          case "font2":
            designer.updateFont2(value);
            break;
          case "font_color1":
            designer.updateFontColor1(value);
            break;
          case "font_color2":
            designer.updateFontColor2(value);
            break;
        }
        recalcPrice();
      }
      hide(list);
      return;
    }
    list.style.display = list.style.display === "block" ? "none" : "block";
  }
  // =============================================
  // 7. MAIN COLOR SELECTION
  // =============================================
  function setupMainColorSelection() {
    const mainColorWrapper = document.getElementById("main-color-type-variant");
    if (!mainColorWrapper) return;
    mainColorWrapper.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected) return;
      mainColorWrapper.querySelectorAll(".sticker-variant").forEach((el) => {
        el.classList.toggle("active", el === selected);
      });
      state.mainColor = selected.dataset.mainColor;
      recalcPrice();
    });
  }
  // =============================================
  // 8. TEXT COLOR #1 SELECTION
  // =============================================
  function setupTextColor1Selection() {
    const swatchContainer = document.querySelector(
      "#text-color-variant1 .letter-color-variants__list"
    );
    const selectedColor = document.getElementById("selected-text-color1");
    if (!swatchContainer || !selectedColor) return;
    swatchContainer.addEventListener("click", (event) => {
      const clickedSwatch = event.target.closest(".pcvb-letter-swatch");
      if (!clickedSwatch || clickedSwatch.classList.contains("active")) return;
      swatchContainer
        .querySelectorAll(".pcvb-letter-swatch")
        .forEach((el) => el.classList.remove("active"));
      clickedSwatch.classList.add("active");
      const value = clickedSwatch.dataset.color;
      if (!value) return;
      selectedColor.textContent = value;
      state.font_color1 = value;
      const customEvent = new Event("change");
      customEvent.target = { value: value };
      document.querySelector("#text-color-variant1").dispatchEvent(customEvent);
      designer.updateFontColor1(value);
    });
  }
  // =============================================
  // 9. TEXT COLOR #2 SELECTION
  // =============================================
  function setupTextColor2Selection() {
    const swatchContainer = document.querySelector(
      "#text-color-variant2 .letter-color-variants__list"
    );
    const selectedColor = document.getElementById("selected-text-color2");
    if (!swatchContainer || !selectedColor) return;
    swatchContainer.addEventListener("click", (event) => {
      const clickedSwatch = event.target.closest(".pcvb-letter-swatch");
      if (!clickedSwatch || clickedSwatch.classList.contains("active")) return;
      swatchContainer
        .querySelectorAll(".pcvb-letter-swatch")
        .forEach((el) => el.classList.remove("active"));
      clickedSwatch.classList.add("active");
      const value = clickedSwatch.dataset.color;
      if (!value) return;
      selectedColor.textContent = value;
      state.font_color2 = value;
      const customEvent = new Event("change");
      customEvent.target = { value: value };
      document.querySelector("#text-color-variant2").dispatchEvent(customEvent);
      designer.updateFontColor2(value);
    });
  }
  // =============================================
  // 10. TEXT INPUT 1 HANDLING
  // =============================================
  function handleTextInput1() {
    const input = document.getElementById("text-input-1");
    const counter = document.getElementById("text-input-1-char-count");
    const error = document.getElementById("text-input-1-error-bar");
    const wrapper = input?.parentElement;
    if (!input || !counter || !error || !wrapper) return;
    const MAX = 200;
    const refresh = () => {
      if (input.value.length > MAX) {
        input.value = input.value.slice(0, MAX);
      }
      state.text1 = input.value;
      const remaining = MAX - input.value.length;
      counter.textContent = `${remaining} character(s) left`;
      if (input.value.trim()) {
        error.style.display = "none";
        wrapper.classList.add("variant-picked");
      } else {
        wrapper.classList.remove("variant-picked");
      }
      if (designer) {
        designer.updateText1(input.value);
      }
    };
    input.addEventListener("input", refresh);
  }
  // =============================================
  // 11. TEXT INPUT 2 HANDLING
  // =============================================
  function handleTextInput2() {
    const input = document.getElementById("text-input-2");
    const counter = document.getElementById("text-input-2-char-count");
    const error = document.getElementById("text-input-2-error-bar");
    if (!input || !counter || !error) return;
    const MAX = 200;
    const refresh = () => {
      if (input.value.length > MAX) {
        input.value = input.value.slice(0, MAX);
      }
      state.text2 = input.value;
      const remaining = MAX - input.value.length;
      counter.textContent = `${remaining} character(s) left`;
      if (input.value.trim()) {
        error.style.display = "none";
      }
      if (designer) {
        designer.updateText2(input.value);
      }
    };
    input.addEventListener("input", refresh);
  }
  // =============================================
  // 12. DESIGN NOTES HANDLING
  // =============================================
  function handleDesignNotesInput() {
    const input = document.getElementById("design-notes-input");
    const counter = document.getElementById("design-notes-char-count");
    if (!input || !counter) return;
    const MAX = 200;
    const refresh = () => {
      if (input.value.length > MAX) {
        input.value = input.value.slice(0, MAX);
      }
      state.design_notes = input.value;
      const remaining = MAX - input.value.length;
      counter.textContent = `${remaining} character(s) left`;
    };
    refresh();
    input.addEventListener("input", refresh);
  }
  // =============================================
  // 14. GROMMET SELECTION
  // =============================================
  function setupGrommetSelection() {
    const variant = document.getElementById("extra-grommets-variant");
    if (!variant) return;
    variant.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected || !variant.contains(selected)) return;
      const list = selected.closest(".sticker-variants__list");
      if (!list) return;
      list.querySelectorAll(".sticker-variant").forEach((el) => {
        el.classList.toggle("active", el === selected);
      });
      const raw =
        selected.dataset.extraGrommets ||
        selected.getAttribute("data-extra-grommets") ||
        "";
      state.extra_grommets = /^yes/i.test(raw)
        ? "Yes"
        : "No";
      recalcPrice();
    });
  }
  // =============================================
  // 15. GROMMET COLOR SELECTION
  // =============================================
  function setupGrommetColorSelection() {
    const variant = document.getElementById("grommet-color-variant");
    if (!variant) return;
    variant.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected || !variant.contains(selected)) return;
      const list = selected.closest(".sticker-variants__list");
      if (!list) return;
      list.querySelectorAll(".sticker-variant").forEach((el) => {
        el.classList.toggle("active", el === selected);
      });
      const value =
        selected.dataset.grommetColor ||
        selected.getAttribute("data-grommet-color") ||
        "Silver";
      state.grommet_color = value;
      recalcPrice();
    });
  }
  // =============================================
  // 16. PACKAGING TYPE SELECTION
  // =============================================
  function setupPackagingTypeSelection() {
    const packagingTypeWrapper = document.getElementById(
      "packaging-type-variant"
    );
    if (!packagingTypeWrapper) return;
    packagingTypeWrapper.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected) return;
      packagingTypeWrapper
        .querySelectorAll(".sticker-variant")
        .forEach((el) => {
          el.classList.toggle("active", el === selected);
        });
      state.packaging_type = selected.dataset.packaging;
      recalcPrice();
    });
  }
  // =============================================
  // 17. PRICE CALCULATION
  // =============================================
  function recalcPrice() {
    let total = priceOf("mainColor", state.mainColor) || 0;
    total += priceOf("size", state.size) || 0;
    total += priceOf("premium_backgrounds", state.premium_backgrounds) || 0;
    total += priceOf("grommet_color", state.grommet_color) || 0;
    total += priceOf("packaging_type", state.packaging_type) || 0;
    total += priceOf("extra_grommets", state.extra_grommets) || 0;
    total = Math.round(total * 100) / 100;
    const priceEl = document.getElementById("pcs-final-price");
    if (priceEl) {
      const prevValue = parseFloat(priceEl.textContent) || 0;
      if (prevValue !== total) {
        animatePriceChange(priceEl, prevValue, total);
      }
    }
    state.price = total;
  }
  // =============================================
  // 18. DELETE BANNER
  // =============================================
  const deleteBannerImage = document.getElementById("delete-banner-image");
  deleteBannerImage.addEventListener("click", (e) => {
    e.preventDefault();
    // Reset sidebar variants
    resetSidebarVariants();
    // Ensure preview-box is hidden and upload-artbox is shown
    const previewBox = document.getElementById("preview-box");
    const mainVariants = document.getElementById("main-variants");
    const sizeSelectMain = document.getElementById("size-select-variant-main");
    const uploadArtbox = document.getElementById("upload-artbox");
    const uploadArtwork = document.getElementById("upload-artwork");
    const btnEditImage = document.getElementById("btnEditImage");
    if (previewBox) {
      previewBox.style.display = "none";
      previewBox.classList.remove("non-editable-image");
    }
    if (mainVariants) mainVariants.classList.remove("active");
    if (sizeSelectMain) sizeSelectMain.classList.remove("active");
    if (uploadArtbox) uploadArtbox.style.display = "block";
    if (btnEditImage) btnEditImage.style.display = "inline";
    // Clear the preview image
    const previewImage = document.getElementById("preview-image");
    if (previewImage) previewImage.src = "";
    // Clear the upload-artwork input
    if (uploadArtwork) uploadArtwork.value = "";
    // Explicitly reset state.artworkImage
    state.artworkImage = null;
    state.editedImage = null;
    updateAddToCartAvailability();
    // Reset and reinitialize the designer
    if (designer) {
      designer.handleRemoveAll();
      designer = new BannerDesigner();
    }
  });

  // =============================================
  // 19. RESET SIDEBAR VARIANTS
  // =============================================
  function resetSidebarVariants() {
    // Reset image uploads
    ["upload-file1", "upload-file2"].forEach((id) => {
      const fileInput = document.getElementById(id);
      if (fileInput) fileInput.value = "";
      const artbox = document.getElementById(`upload-artbox${id.slice(-1)}`);
      const previewBox = document.getElementById(`preview-box${id.slice(-1)}`);
      if (artbox) artbox.style.display = "block";
      if (previewBox) previewBox.style.display = "none";
      const previewImg = document.getElementById(`preview-image${id.slice(-1)}`);
      if (previewImg) previewImg.src = "";
    });
    state.uploadedImage1 = null;
    state.uploadedImage2 = null;
    state.editedImage = null;
    state.artworkImage = null;
    updateAddToCartAvailability();

    // Reset sidebar dropdowns (size, color, premium backgrounds, font1, font2)
    ["size", "color", "premium_backgrounds", "font1", "font2"].forEach((key) => {
      const dropdown = document.getElementById(`${key}-select`);
      if (dropdown) {
        const list = dropdown.querySelector(".dropdown-options");
        const header = dropdown.querySelector(".selected-text");
        if (list && header) {
          list.querySelectorAll("li").forEach((li) => li.classList.remove("selected"));
          const firstOption = list.querySelector("li[data-value]");
          if (firstOption) {
            firstOption.classList.add("selected");
            header.textContent = firstOption.textContent.trim();
            state[key] = firstOption.dataset.value;
            if (key === "font1" || key === "font2") {
              header.classList.forEach((cls) => {
                if (cls.startsWith('font-')) header.classList.remove(cls);
              });
              firstOption.classList.forEach((cls) => {
                if (cls.startsWith('font-')) header.classList.add(cls);
              });
            }
            // Trigger change event
            const customEvent = new Event("change");
            customEvent.target = { value: firstOption.dataset.value };
            dropdown.dispatchEvent(customEvent);
          }
          hide(list);
          dropdown.classList.remove("variant-picked");
        }
      }
    });

    ["size-select", "size-select-main"].forEach((id) => {
      const dropdown = document.getElementById(id);
      if (dropdown) {
        const list = dropdown.querySelector(".dropdown-options");
        const header = dropdown.querySelector(".selected-text");
        if (list && header) {
          list.querySelectorAll("li").forEach((li) => li.classList.remove("selected"));
          const firstOption = list.querySelector("li[data-value]");
          if (firstOption) {
            firstOption.classList.add("selected");
            header.textContent = firstOption.textContent.trim();
            if (id === "size-select" || id === "size-select-main") {
              state.size = firstOption.dataset.value;
            }
          }
          hide(list);
          dropdown.classList.remove("variant-picked");
        }
      }
    });

    // Explicitly reset premium_backgrounds to "None"
    state.premium_backgrounds = "None";
    const premiumBackgroundSelect = document.getElementById("premium-backgrounds-select");
    if (premiumBackgroundSelect) {
      const list = premiumBackgroundSelect.querySelector(".dropdown-options");
      const header = premiumBackgroundSelect.querySelector(".selected-text");
      if (list && header) {
        list.querySelectorAll("li").forEach((li) => li.classList.remove("selected"));
        const noneOption = list.querySelector("li[data-value='None']");
        if (noneOption) {
          noneOption.classList.add("selected");
          header.textContent = noneOption.textContent.trim();
          const customEvent = new Event("change");
          customEvent.target = { value: "None" };
          premiumBackgroundSelect.dispatchEvent(customEvent);
        }
      }
    }

    // Reset text inputs
    const text1 = document.getElementById("text-input-1");
    if (text1) {
      text1.value = "";
      state.text1 = null;
      const counter = document.getElementById("text-input-1-char-count");
      if (counter) counter.textContent = "200 character(s) left";
      if (designer) designer.updateText1("");
    }
    const text2 = document.getElementById("text-input-2");
    if (text2) {
      text2.value = "";
      state.text2 = null;
      const counter2 = document.getElementById("text-input-2-char-count");
      if (counter2) counter2.textContent = "200 character(s) left";
      if (designer) designer.updateText2("");
    }

    // Reset font color selections
    const colorList1 = document.querySelectorAll(
      "#text-color-variant1 .letter-color-variants__list .pcvb-letter-swatch"
    );
    if (colorList1.length) {
      colorList1.forEach((el) => el.classList.remove("active"));
      const first = colorList1[0];
      first.classList.add("active");
      state.font_color1 = first.dataset.color || "Black";
      const selTxt = document.getElementById("selected-text-color1");
      if (selTxt) selTxt.textContent = state.font_color1;
      const customEvent = new Event("change");
      customEvent.target = { value: state.font_color1 };
      document.querySelector("#text-color-variant1").dispatchEvent(customEvent);
    }
    const colorList2 = document.querySelectorAll(
      "#text-color-variant2 .letter-color-variants__list .pcvb-letter-swatch"
    );
    if (colorList2.length) {
      colorList2.forEach((el) => el.classList.remove("active"));
      const first2 = colorList2[0];
      first2.classList.add("active");
      state.font_color2 = first2.dataset.color || "Black";
      const selTxt2 = document.getElementById("selected-text-color2");
      if (selTxt2) selTxt2.textContent = state.font_color2;
      const customEvent = new Event("change");
      customEvent.target = { value: state.font_color2 };
      document.querySelector("#text-color-variant2").dispatchEvent(customEvent);
    }

    // Clear errors
    document.querySelectorAll(".error-bar").forEach((el) => hide(el));
    document
      .querySelectorAll(".pcs-variant")
      .forEach((el) => el.classList.remove("has-error"));

    // Recalculate price
    recalcPrice();
  }
  // =============================================
  // 20. FORM VALIDATION
  // =============================================
  function validateForm() {
    let firstInvalid = null;
    function toggleError(id, show, message = "") {
      const bar = document.getElementById(id);
      if (!bar) return;
      if (message) bar.textContent = message;
      bar.style.display = show ? "block" : "none";
      const variantBox = bar.closest(".pcs-variant");
      if (variantBox) variantBox.classList.toggle("has-error", show);
      if (show && !firstInvalid) firstInvalid = variantBox || bar;
    }
    const text1El = document.getElementById("text-input-1");
    const text1Val = (text1El ? text1El.value : "").trim();
    state.text1 = text1Val || null;
    const text2El = document.getElementById("text-input-2");
    const text2Val = (text2El ? text2El.value : "").trim();
    state.text2 = text2Val || null;
    const t2Err = document.getElementById("text-input-2-error-bar");
    if (t2Err) t2Err.style.display = "none";
    const sizeDropdown = document.getElementById("size-select-variant");
    const sizePicked = !!(
      sizeDropdown && sizeDropdown.classList.contains("variant-picked")
    );
    const hasSize = sizePicked || !!state.size;
    toggleError("size-error-bar", !hasSize, "Please select a size.");
    const pbSelect = document.getElementById("premium-backgrounds-select");
    if (pbSelect) {
      const sel = pbSelect.querySelector(".dropdown-options li.selected");
      if (sel)
        state.premium_backgrounds = sel.getAttribute("data-value") || "None";
    }
    const colorSelect = document.getElementById("color-select");
    if (colorSelect) {
      const sel = colorSelect.querySelector(".dropdown-options li.selected");
      if (sel) state.color = sel.getAttribute("data-value") || "None";
    }
    const packSelect = document.getElementById("packaging-type-variant");
    if (packSelect) {
      const sel = packSelect.querySelector(".dropdown-options li.selected");
      if (sel)
        state.packaging_type =
          sel.getAttribute("data-value") || state.packaging_type;
    }
    const grommetSelect = document.getElementById("grommet-color-variant");
    if (grommetSelect) {
      const sel = grommetSelect.querySelector(".dropdown-options li.selected");
      if (sel)
        state.grommet_color =
          sel.getAttribute("data-value") || state.grommet_color;
    }
    const extraGrommetsSelect = document.getElementById(
      "extra-grommets-variant"
    );
    if (extraGrommetsSelect) {
      const sel = extraGrommetsSelect.querySelector(
        ".dropdown-options li.selected"
      );
      if (sel)
        state.extra_grommets =
          sel.getAttribute("data-value") || state.extra_grommets;
    }
    if (firstInvalid) {
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
      return false;
    }
    return true;
  }
  // =============================================
  // 21. RESET FORM
  // =============================================
  function resetCalculatorForm() {
    ["upload-file1", "upload-file2"].forEach((id) => {
      const fileInput = document.getElementById(id);
      if (fileInput) fileInput.value = "";
      const artbox = document.getElementById(`upload-artbox${id.slice(-1)}`);
      const previewBox = document.getElementById(`preview-box${id.slice(-1)}`);
      const previewImg = document.getElementById(`preview-image${id.slice(-1)}`);
      if (artbox) artbox.style.display = "block";
      if (previewBox) previewBox.style.display = "none";
      if (previewImg) previewImg.src = "";
    });
    state.uploadedImage1 = null;
    state.uploadedImage2 = null;
    state.editedImage = null;
    state.artworkImage = null;
    updateAddToCartAvailability();

    ["size-select", "size-select-main"].forEach((id) => {
      const dropdown = document.getElementById(id);
      if (dropdown) {
        const list = dropdown.querySelector(".dropdown-options");
        const header = dropdown.querySelector(".selected-text");
        if (list && header) {
          list.querySelectorAll("li").forEach((li) => li.classList.remove("selected"));
          const firstOption = list.querySelector("li[data-value]");
          if (firstOption) {
            firstOption.classList.add("selected");
            header.textContent = firstOption.textContent.trim();
          }
          hide(list);
          dropdown.classList.remove("variant-picked");
        }
      }
    });

    // Ensure preview-box is hidden and upload-artbox is shown
    const previewBox = document.getElementById("preview-box");
    const mainVariants = document.getElementById("main-variants");
    const uploadArtbox = document.getElementById("upload-artbox");
    const uploadArtwork = document.getElementById("upload-artwork");
    const sizeSelectMain = document.getElementById("size-select-variant-main");
    const btnEditImage = document.getElementById("btnEditImage");
    if (previewBox) previewBox.style.display = "none";
    if (mainVariants) mainVariants.classList.remove("active");
    if (uploadArtbox) uploadArtbox.style.display = "block";
    if (uploadArtwork) uploadArtwork.value = "";
    if (sizeSelectMain) sizeSelectMain.classList.remove("active");
    if (btnEditImage) btnEditImage.style.display = "inline";
    // Clear the preview image
    const previewImage = document.getElementById("preview-image");
    if (previewImage) previewImage.src = "";

    document.querySelectorAll(".select-dropdown").forEach((dd) => {
      const list = dd.querySelector(".dropdown-options");
      const header = dd.querySelector(".selected-text");
      if (!list || !header) return;
      list
        .querySelectorAll("li")
        .forEach((li) => li.classList.remove("selected"));
      const firstOption = list.querySelector("li[data-value]");
      if (firstOption) {
        firstOption.classList.add("selected");
        header.textContent = firstOption.textContent.trim();
        const stateKey = dd.dataset.stateKey;
        if (stateKey) state[stateKey] = firstOption.dataset.value;
      }
      hide(list);
      dd.classList.remove("variant-picked");
    });
    const colorList1 = document.querySelectorAll(
      "#text-color-variant1 .letter-color-variants__list .pcvb-letter-swatch"
    );
    if (colorList1.length) {
      colorList1.forEach((el) => el.classList.remove("active"));
      const first = colorList1[0];
      first.classList.add("active");
      state.font_color1 = first.dataset.color || "Black";
      const selTxt = document.getElementById("selected-text-color1");
      if (selTxt) selTxt.textContent = state.font_color1;
    }
    const colorLists = document.querySelectorAll(
      ".letter-color-variants__list"
    );
    if (colorLists.length > 1) {
      const secondList = colorLists[1].querySelectorAll(".pcvb-letter-swatch");
      secondList.forEach((el) => el.classList.remove("active"));
      const first2 = secondList[0];
      first2.classList.add("active");
      state.font_color2 = first2.dataset.color || "Black";
      const selTxt2 = document.getElementById("selected-text-color2");
      if (selTxt2) selTxt2.textContent = state.font_color2;
    }
    const text1 = document.getElementById("text-input-1");
    if (text1) {
      text1.value = "";
      state.text1 = null;
      const counter = document.getElementById("text-input-1-char-count");
      if (counter) counter.textContent = "200 character(s) left";
      if (designer) designer.updateText1("");
    }
    const text2 = document.getElementById("text-input-2");
    if (text2) {
      text2.value = "";
      state.text2 = null;
      const counter2 = document.getElementById("text-input-2-char-count");
      if (counter2) counter2.textContent = "200 character(s) left";
      if (designer) designer.updateText2("");
    }
    const notes = document.getElementById("design-notes-input");
    if (notes) {
      notes.value = "";
      state.design_notes = null;
      const notesCount = document.getElementById("design-notes-char-count");
      if (notesCount) notesCount.textContent = "200 character(s) left";
    }
    const extraWrap = document.getElementById("extra-grommets-variant");
    if (extraWrap) {
      const items = extraWrap.querySelectorAll(".sticker-variant");
      items.forEach((el) => el.classList.remove("active"));
      if (items.length) {
        items[0].classList.add("active");
        state.extra_grommets = "No";
      }
    }
    const gromWrap = document.getElementById("grommet-color-variant");
    if (gromWrap) {
      const items = gromWrap.querySelectorAll(".sticker-variant");
      items.forEach((el) => el.classList.remove("active"));
      if (items.length) {
        items[0].classList.add("active");
        state.grommet_color = items[0].dataset.grommetColor || "Silver";
      }
    }
    const packWrap = document.getElementById("packaging-type-variant");
    if (packWrap) {
      const items = packWrap.querySelectorAll(".sticker-variant");
      items.forEach((el) => el.classList.remove("active"));
      if (items.length) {
        items[0].classList.add("active");
        state.packaging_type = "Folded in a Box";
      }
    }
    state.size = "4'x1'";
    state.premium_backgrounds = "None";
    state.color = "None";
    state.mainColor = "Standard";
    state.price = 0;
    document.querySelectorAll(".error-bar").forEach((el) => hide(el));
    document
      .querySelectorAll(".pcs-variant")
      .forEach((el) => el.classList.remove("has-error"));
    recalcPrice();
    if (designer) {
      designer.uploadedImage1 = null;
      designer.uploadedImage2 = null;
      designer.text1 = null;
      designer.text2 = null;
      designer.backgroundImage = null;
      designer.backgroundRect = null;
      designer.guidelineObjects = [];
      if (designer.canvas) {
        designer.canvas.discardActiveObject();
        designer.canvas.clear();
        designer.canvas.clipPath = null;
      }
      designer.clipPath = null;
      designer.drawClipPath();
      designer.updateFinishButtonState();
    }
    updateAddToCartAvailability();
  }
  // =============================================
  // 22. ADD TO CART FUNCTIONALITY
  // =============================================
  function setupApippaAddToCart() {
    const addToCartBtn = document.getElementById("pcvb-add-to-cart");
    if (!addToCartBtn) return;
    const PCVB_CART_BTN_HTML = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.5"></circle><circle cx="18" cy="20" r="1.5"></circle><path d="M2 3h3l2.4 12.4a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.6L23 6H6"></path></svg><span>Add to cart</span>`;
    const PCVB_CART_LOADING_HTML = `<span class="pcvb-cart-loading"><svg class="pcvb-cart-loading__icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-6.22-8.56"></path></svg>Adding to cart</span>`;
    addToCartBtn.innerHTML = PCVB_CART_BTN_HTML;
    updateAddToCartAvailability();
    addToCartBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      if (!hasRequiredArtworkForCart()) {
        updateAddToCartAvailability();
        return;
      }
      if (!validateForm()) {
        console.log("Form invalid – fix the highlighted fields.");
        return;
      }
      console.log("Form valid – adding to cart:", state);
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add("loading");
      addToCartBtn.innerHTML = PCVB_CART_LOADING_HTML;
      try {
        const requestData = {
          calculatorId: "142c85764a534",
          productId: 7717765742640,
          properties: {
            Size: state.size,
            "Main Color": state.mainColor,
            Color: state.color,
            "Premium Background": state.premium_backgrounds,
            "Text #1": state.text1 || "",
            "Text #2": state.text2 || "",
            "Font #1": state.text1?.trim() ? state.font1 : "",
            "Font #2": state.text2?.trim() ? state.font2 : "",
            "Font Color #1": state.text1?.trim() ? state.font_color1 : "",
            "Font Color #2": state.text2?.trim() ? state.font_color2 : "",
            "Grommet Color": state.grommet_color,
            "Add Extra Grommets?": state.extra_grommets,
            "Packaging Type": state.packaging_type,
            "Design Notes, Reorders, Etc": state.design_notes || "",
            "Upload Image 1": state.uploadedImage1?.name || "",
            "Upload Image 2": state.uploadedImage2?.name || "",
            "Edited Image": state.editedImage?.name || "",
            "Artwork Image": state.artworkImage || "",
          },
        };
        console.log("Request Data: ", requestData);
        const variantRes = await fetch(
          "https://api.custompricecalculator.com/api/v1/variant",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(requestData),
          }
        );
        const variantId = await variantRes.json();
        const shopifyVariantId =
          typeof variantId === "string"
            ? variantId
            : variantId?.variantId || variantId?.id;
        if (!shopifyVariantId) throw new Error("Invalid variant ID");
        const formData = new FormData();
        formData.append("id", shopifyVariantId);
        formData.append("quantity", 1);
        Object.entries(requestData.properties).forEach(([key, value]) => {
          formData.append(`properties[${key}]`, value);
        });
        if (state.uploadedImage1) {
          formData.append("properties[Upload Image 1]", state.uploadedImage1);
        }
        if (state.uploadedImage2) {
          formData.append("properties[Upload Image 2]", state.uploadedImage2);
        }
        if (state.editedImage) {
          formData.append("properties[Edited Image]", state.editedImage);
        }
        const cartAddRes = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });
        const cartAddJson = await cartAddRes.json();
        console.log("Add to Cart Response:", cartAddJson);
        localStorage.setItem(
          `patched-cart-item-${cartAddJson.id}`,
          JSON.stringify({
            id: cartAddJson.id,
            title: cartAddJson.product_title,
            image: cartAddJson.image,
            price: cartAddJson.price,
          })
        );
        if (!cartAddRes.ok) throw new Error("Failed to add to cart");
        const cartJson = {
          items: [cartAddJson],
          item_count: 1,
          total_price: cartAddJson.final_price,
          original_total_price: cartAddJson.original_price,
          total_discount: 0,
        };
        const timestamp = new Date().getTime();
        await new Promise((resolve) => setTimeout(resolve, 200));
        const sectionHtml = await fetch(
          `/cart?section_id=mini-cart&t=${timestamp}`
        ).then((res) => res.text());
        const fakeDiv = document.createElement("div");
        fakeDiv.innerHTML = sectionHtml;
        const miniCartHTML = fakeDiv.querySelector("cart-drawer")?.outerHTML;
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer && miniCartHTML) {
          cartDrawer.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: {
                  ...cartJson,
                  sections: {
                    "mini-cart": miniCartHTML,
                  },
                },
                openMiniCart: true,
              },
            })
          );
        }
        setTimeout(() => {
          const lineItems = cartDrawer.querySelectorAll("line-item");
          lineItems.forEach((lineItem) => {
            const desktopPriceContainer = lineItem.querySelector(
              ".line-item__price-list-container .price"
            );
            const mobilePriceContainer = lineItem.querySelector(
              ".product-item-meta__price-list-container .price-list.hidden-tablet-and-up .price"
            );
            if (!desktopPriceContainer && !mobilePriceContainer) return;
            const priceText = (
              desktopPriceContainer || mobilePriceContainer
            ).textContent.trim();
            const isFree = /Free|\$0\.00/.test(priceText);
            let variantId;
            const productLink = lineItem.querySelector("a[href*='?variant=']");
            if (productLink?.href.includes("variant=")) {
              variantId = productLink.href.split("variant=")[1].split("&")[0];
            }
            if (!variantId) {
              const removeBtn = lineItem.querySelector(
                "a[href*='/cart/change?id=']"
              );
              const removeHref = removeBtn?.getAttribute("href") || "";
              const match = removeHref.match(/id=(\d+):/);
              variantId = match?.[1];
            }
            if (isFree && variantId == shopifyVariantId) {
              const matchingItem = cartJson.items.find(
                (item) => String(item.id) === variantId
              );
              if (matchingItem) {
                const correctPrice = (matchingItem.price / 100).toFixed(2);
                const imageWrapper = lineItem.querySelector(
                  ".line-item__image-wrapper"
                );
                const productThumbnail = imageWrapper.querySelector(
                  "img.line-item__image"
                );
                const productTitle = lineItem.querySelector(
                  ".product-item-meta .product-item-meta__title"
                );
                if (!productThumbnail) {
                  const imgSrc = document.querySelector(
                    ".product__thumbnail-item .product__thumbnail img"
                  )?.src;
                  if (imgSrc) {
                    imageWrapper.innerHTML += `
                      <img src="${imgSrc}" alt="" srcset="${imgSrc}" width="1024" height="1024" width="1024" loading="lazy" sizes="(max-width: 740px) 80px, 92px" class="line-item__image">
                    `;
                  }
                }
                if (productTitle.textContent.trim() === "") {
                  productTitle.textContent = document.querySelector(
                    ".product__info .product-meta__title"
                  ).textContent;
                }
                const updatedPriceHTML = `
                  <span class="visually-hidden">Sale price</span>
                  $${correctPrice}
                `;
                if (desktopPriceContainer) {
                  desktopPriceContainer.innerHTML = updatedPriceHTML;
                }
                if (mobilePriceContainer) {
                  mobilePriceContainer.innerHTML = updatedPriceHTML;
                }
              }
            }
          });
        }, 300);
        setTimeout(async () => {
          const cartJson = await fetch("/cart.js").then((res) => res.json());
          const cartCountEl = document.querySelector("cart-count");
          if (cartCountEl) {
            cartCountEl.textContent = cartJson.item_count;
          }
        }, 300);
        setTimeout(() => {
          const drawerContent = document.querySelector(
            "#shopify-section-mini-cart .drawer__content"
          );
          if (!drawerContent) return;
          const confetti = document.createElement("dotlottie-player");
          confetti.className = "mini-cart-lottie";
          confetti.src =
            "//cdn.shopify.com/s/files/1/0582/5400/0176/files/confetti.json?v=1748024242";
          confetti.setAttribute("background", "transparent");
          confetti.setAttribute("speed", "1");
          confetti.setAttribute("style", "width: 300px; height: 300px");
          confetti.setAttribute("direction", "1");
          confetti.setAttribute("playmode", "normal");
          confetti.setAttribute("autoplay", "");
          drawerContent.prepend(confetti);
          setTimeout(() => {
            confetti.remove();
          }, 3000);
        }, 1000);
      } catch (err) {
        console.error("Apippa Add to Cart Error:", err);
        alert("There was a problem adding your item to the cart.");
      } finally {
        addToCartBtn.classList.remove("loading");
        addToCartBtn.innerHTML = PCVB_CART_BTN_HTML;
        resetCalculatorForm();
        updateAddToCartAvailability();
      }
    });
  }
  // =============================================
  // 23. BANNER DESIGNER CLASS
  // =============================================
  class BannerDesigner {
    constructor() {
      this.canvas = null;
      this.clipPath = null;
      this.backgroundRect = null;
      this.guidelineObjects = [];
      this.backgroundImage = null;
      this.uploadedImage1 = null;
      this.uploadedImage2 = null;
      this.text1 = null;
      this.text2 = null;
      this.snappingEnabled = true;
      this._ro = null;
      this._previewRefreshTimer = null;
      this.icons = {
        resizeLeft: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/white-resize-left.webp",
        resizeRight: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/white-resize-right.webp",
        resizeHorizontal: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/white-resize-horizontal.webp",
        stackUp: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/stackup.webp",
        stackDown: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/stackdown.webp",
        rotate: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/rotate.webp"
      };
      this.init();
    }

    init() {
      const canvasContainer = document.getElementById("canvasContainer");
      if (!canvasContainer) {
        console.error("Canvas container not found");
        return;
      }
      canvasContainer.innerHTML = '<canvas id="stickerCanvas"></canvas>';
      this.canvas = new fabric.Canvas("stickerCanvas", {
        width: canvasContainer.offsetWidth,
        height: canvasContainer.offsetHeight,
        preserveObjectStacking: true,
        controlsAboveOverlay: true,
        selection: true,
      });
      this.setupCanvas();
      this.setupEventListeners();
      this.setupCustomControls();
      this.observeContainerResize(canvasContainer);
      this.updateCanvasSize();
      this.drawClipPath();
      this.updateFinishButtonState();
    }

    observeContainerResize(container) {
      const ro = new ResizeObserver(
        debounce(() => this.handleResize(), 120)
      );
      ro.observe(container);
      this._ro = ro;
    }

    setupCanvas() {
      if (!this.canvas) return;
      this.canvas.preserveObjectStacking = true;
      this.canvas.controlsAboveOverlay = true;
      this.canvas.selection = true;
    }

    setupEventListeners() {
      window.addEventListener(
        "resize",
        debounce(() => this.handleResize(), 300)
      );

      document.addEventListener("keydown", (e) => {
        const obj = this.canvas?.getActiveObject();
        if (!obj) return;
        const mod = e.ctrlKey || e.metaKey;

        if (mod && e.key === "]") {
          const cur = this.canvas.getObjects().indexOf(obj);
          const maxIdx = this._topCeilingIndex();
          if (cur < maxIdx) this.canvas.bringForward(obj);
          this._guardZ(obj);
          e.preventDefault();
        } else if (mod && e.key === "[") {
          const cur = this.canvas.getObjects().indexOf(obj);
          const minIdx = this._bgTopIndex() + 1;
          if (cur > minIdx) this.canvas.sendBackwards(obj);
          this._guardZ(obj);
          e.preventDefault();
        }
      });

      const getStartedBtn = document.getElementById("get-started-btn");
      if (getStartedBtn) {
        getStartedBtn.addEventListener("click", () => {
          const designerTool = document.getElementById("designerTool");
          if (designerTool) {
            designerTool.classList.add("active");
            disableBodyScroll();
            state.artworkImage = null; // Explicitly reset state.artworkImage
            updateAddToCartAvailability();
            console.log("state.artworkImage set to null in getStartedBtn click");
          }
          this.drawClipPath();
        });
      }
      const closeBtn = document.getElementById("designer-tool-close-btn");
      const mountCloseToolPopup = () => {
        const popup = document.getElementById("close-tool-popup");
        const designerTool = document.getElementById("designerTool");
        if (popup && popup.parentElement !== document.body) {
          document.body.appendChild(popup);
        }
        return { popup, designerTool };
      };
      const setCloseToolPopupOpen = (isOpen) => {
        const { popup, designerTool } = mountCloseToolPopup();
        if (popup) popup.classList.toggle("active", isOpen);
        if (designerTool) designerTool.classList.toggle("pcvb-popup-open", isOpen);
        document.documentElement.classList.toggle("pcvb-close-popup-open", isOpen);
        document.body.classList.toggle("pcvb-close-popup-open", isOpen);
      };
      const { popup: closeToolPopup } = mountCloseToolPopup();
      if (closeToolPopup) {
        const keepPopupStill = (event) => {
          if (closeToolPopup.classList.contains("active")) {
            event.preventDefault();
          }
        };
        closeToolPopup.addEventListener("wheel", keepPopupStill, { passive: false });
        closeToolPopup.addEventListener("touchmove", keepPopupStill, { passive: false });
      }
      if (closeBtn) {
        closeBtn.addEventListener("click", () => {
          setCloseToolPopupOpen(true);
        });
      }
      const cancelClose = document.getElementById("cancel-close-tool");
      if (cancelClose) {
        cancelClose.addEventListener("click", () => {
          setCloseToolPopupOpen(false);
        });
      }
      const confirmClose = document.getElementById("confirm-close-tool");
      if (confirmClose) {
        confirmClose.addEventListener("click", () => {
          const designerTool = document.getElementById("designerTool");
          setCloseToolPopupOpen(false);
          if (designerTool) {
            designerTool.classList.remove("active");
            enableBodyScroll();
          }
        });
      }
      const toggleGuides = document.getElementById("toggleGuides");
      if (toggleGuides) {
        toggleGuides.addEventListener("change", (e) => {
          this.toggleGuidelines(e.target.checked);
        });
      }
      const toggleSnap = document.getElementById("toggleSnap");
      if (toggleSnap) {
        toggleSnap.addEventListener("change", (e) => {
          this.snappingEnabled = e.target.checked;
        });
      }
      const btnEditImage = document.getElementById("btnEditImage");
      if (btnEditImage) {
        btnEditImage.addEventListener("click", (e) => {
          const designerTool = document.getElementById("designerTool");
          if (designerTool) {
            designerTool.classList.add("active");
            disableBodyScroll();
          }
        });
      }
      document
        .querySelectorAll(".align-btn")
        .forEach((btn) =>
          btn.addEventListener("click", (e) =>
            this.alignObjects(e.currentTarget.dataset.align)
          )
        );
      document.querySelectorAll(".text-align-btn").forEach((btn) =>
        btn.addEventListener("click", (e) => {
          const align = e.currentTarget.dataset.textAlign;
          const active = this.canvas.getActiveObject();
          if (active && (active.type === "text" || active.type === "textbox")) {
            active.set("textAlign", align);
            this.canvas.renderAll();
          }
        })
      );
      const finishEditing = document.getElementById("finishEditing");
      if (finishEditing) {
        finishEditing.addEventListener("click", () => this.finishEditing());
      }
      const uploadFile1 = document.getElementById("upload-file1");
      if (uploadFile1) {
        uploadFile1.addEventListener("change", (e) =>
          this.handleImageUpload1(e)
        );
      }
      const uploadFile2 = document.getElementById("upload-file2");
      if (uploadFile2) {
        uploadFile2.addEventListener("change", (e) =>
          this.handleImageUpload2(e)
        );
      }
      const textInput1 = document.getElementById("text-input-1");
      if (textInput1) {
        textInput1.addEventListener("input", (e) =>
          this.updateText1(e.target.value)
        );
      }
      const textInput2 = document.getElementById("text-input-2");
      if (textInput2) {
        textInput2.addEventListener("input", (e) =>
          this.updateText2(e.target.value)
        );
      }
      const font1Select = document.getElementById("font1-select");
      if (font1Select) {
        font1Select.addEventListener("change", (e) => {
          if (e.target.value) this.updateFont1(e.target.value);
        });
      }
      const font2Select = document.getElementById("font2-select");
      if (font2Select) {
        font2Select.addEventListener("change", (e) => {
          if (e.target.value) this.updateFont2(e.target.value);
        });
      }
      const textColorVariant1 = document.querySelector("#text-color-variant1");
      if (textColorVariant1) {
        textColorVariant1.addEventListener("change", (e) => {
          if (e.target.value) this.updateFontColor1(e.target.value);
        });
      }
      const textColorVariant2 = document.querySelector("#text-color-variant2");
      if (textColorVariant2) {
        textColorVariant2.addEventListener("change", (e) => {
          if (e.target.value) this.updateFontColor2(e.target.value);
        });
      }
      const colorSelect = document.getElementById("color-select");
      if (colorSelect) {
        colorSelect.addEventListener("change", (e) => {
          if (e.target.value) this.updateBackgroundColor(e.target.value);
        });
      }
      const premiumBackgroundSelect = document.getElementById(
        "premium-backgrounds-select"
      );
      if (premiumBackgroundSelect) {
        premiumBackgroundSelect.addEventListener("change", (e) => {
          if (e.target.value) this.updatePremiumBackground(e.target.value);
        });
      }
      const sizeSelect = document.getElementById("size-select");
      if (sizeSelect) {
        sizeSelect.addEventListener("change", (e) => {
          if (e.target.value) this.updateSize(e.target.value);
        });
      }
      this.canvas.on("selection:created", (e) => {
        if (e.selected && e.selected.length === 1) {
          const t = e.selected[0];
          if (t.type === "text" || t.type === "textbox") {
            const tools = document.getElementById("text-align-tools");
            if (tools) tools.style.display = "flex";
          }
        }
      });
      this.canvas.on("selection:updated", (e) => {
        const tools = document.getElementById("text-align-tools");
        const onlyOne = e.selected && e.selected.length === 1;
        const isText = onlyOne && (e.selected[0].type === "text" || e.selected[0].type === "textbox");
        if (tools) tools.style.display = isText ? "flex" : "none";
      });
      this.canvas.on("selection:cleared", () => {
        const textAlignTools = document.getElementById("text-align-tools");
        if (textAlignTools) textAlignTools.style.display = "none";
      });
      this.canvas.on("object:moving", (e) => {
        if (!this.snappingEnabled || !this.clipPath) return;

        const obj = e.target;
        if (!obj) return;

        const threshold = 10;
        const cur = obj.getCenterPoint();
        const clipBR = this.clipPath.getBoundingRect(true);
        const clipCX = clipBR.left + clipBR.width / 2;
        const clipCY = clipBR.top + clipBR.height / 2;

        let targetCX = cur.x;
        let targetCY = cur.y;

        if (Math.abs(cur.x - clipCX) <= threshold) targetCX = clipCX;
        if (Math.abs(cur.y - clipCY) <= threshold) targetCY = clipCY;

        obj.setPositionByOrigin(new fabric.Point(targetCX, targetCY), "center", "center");
        obj.setCoords();

        this.canvas.requestRenderAll();
      });

      this.canvas.on("object:added", (e) => {
        if (this.guidelineObjects.length) this._bringGuidesToFront();
      });
    }

    setupCustomControls() {
      const preload = (src) =>
        new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = "anonymous";
          img.onload = () => resolve(img);
          img.onerror = reject;
          img.src = src;
        });

      Promise.all([
        preload(this.icons.resizeLeft),
        preload(this.icons.resizeRight),
        preload(this.icons.resizeHorizontal),
        preload(this.icons.stackUp),
        preload(this.icons.stackDown),
        preload(this.icons.rotate)
      ]).then(([resizeLeftImg, resizeRightImg, resizeHImg, stackUpImg, stackDownImg, rotateImg]) => {
        this.applyCustomCornerIcons(
          resizeLeftImg, resizeRightImg, resizeHImg, stackUpImg, stackDownImg, rotateImg
        );
      }).catch((e) => console.warn("Icon preload failed:", e));

      fabric.Object.prototype.transparentCorners = false;
      fabric.Object.prototype.cornerColor = "black";
      fabric.Object.prototype.borderColor = "black";
      fabric.Object.prototype.cornerStyle = "circle";
      fabric.Object.prototype.cornerStrokeColor = "black";
      fabric.Object.prototype.borderScaleFactor = 1;
    }

    _topCeilingIndex() {
      if (!this.canvas) return -1;
      const objs = this.canvas.getObjects();
      let minGuide = Infinity;
      this.guidelineObjects.forEach(g => {
        const idx = objs.indexOf(g);
        if (idx !== -1) minGuide = Math.min(minGuide, idx);
      });
      return (minGuide === Infinity) ? objs.length - 1 : (minGuide - 1);
    }

    _bringGuidesToFront() {
      if (!this.canvas) return;
      this.guidelineObjects.forEach(g => this.canvas.bringToFront(g));
      this.canvas.requestRenderAll();
    }

    _bgTopIndex() {
      if (!this.canvas) return -1;
      const objs = this.canvas.getObjects();
      let idx = -1;
      if (this.backgroundRect) idx = Math.max(idx, objs.indexOf(this.backgroundRect));
      if (this.backgroundImage) idx = Math.max(idx, objs.indexOf(this.backgroundImage));
      return idx;
    }

    _guardZ(obj) {
      if (!this.canvas || !obj) return;

      if (this.guidelineObjects?.length) this._bringGuidesToFront();

      const objs = this.canvas.getObjects();
      const bgTop = this._bgTopIndex();
      const topCap = this._topCeilingIndex();

      let cur = objs.indexOf(obj);
      if (bgTop >= 0 && cur <= bgTop) this.canvas.moveTo(obj, bgTop + 1);

      cur = objs.indexOf(obj);
      if (topCap >= 0 && cur > topCap) this.canvas.moveTo(obj, topCap);

      this.canvas.requestRenderAll();
    }

    applyCustomCornerIcons(iconLeft, iconRight, iconHorizontal, iconStackUp, iconStackDown, iconRotate) {
      const renderIcon = (icon) => function (ctx, left, top, _style, fabricObject) {
        const size = this.cornerSize || 24;
        ctx.save();
        ctx.translate(left, top);
        ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle || 0));
        ctx.drawImage(icon, -size / 2, -size / 2, size, size);
        ctx.restore();
      };

      const setCtrl = (key, opts) => {
        const ctrl = fabric.Object.prototype.controls[key];
        if (ctrl) Object.assign(ctrl, opts);
      };

      const cornerSize = 25;
      setCtrl("tl", { render: renderIcon(iconLeft), cornerSize });
      setCtrl("tr", { render: renderIcon(iconRight), cornerSize });
      setCtrl("bl", { render: renderIcon(iconRight), cornerSize });
      setCtrl("br", { render: renderIcon(iconLeft), cornerSize });

      const midSize = 25;
      setCtrl("ml", { render: renderIcon(iconHorizontal), cornerSize: midSize });
      setCtrl("mr", { render: renderIcon(iconHorizontal), cornerSize: midSize });

      fabric.Object.prototype.setControlsVisibility({ mt: false, mb: false, ml: false, mr: false });

      const SIDE_OFFSET = 30;
      const self = this;

      const ICON_SIZE = 25; 
      const OFFSET_X = 25;
      const OFFSET_Y = 12;
      const GAP_Y = 6;

      const makeTopRightControl = (name, order, iconImg, onClick) => {
        fabric.Object.prototype.controls[name] = new fabric.Control({
          x: 0.5,
          y: -0.5,
          offsetX: OFFSET_X,
          offsetY: OFFSET_Y + order * (ICON_SIZE + GAP_Y),
          cornerSize: ICON_SIZE,
          cursorStyle: "pointer",
          render: renderIcon(iconImg),
          mouseUpHandler: (_evt, transform) => {
            const obj = transform.target;
            if (!obj || !obj.canvas) return;
            onClick(obj);
            self._guardZ(obj);
            obj.canvas.setActiveObject(obj);
            obj.canvas.requestRenderAll();
          }
        });
      };

      makeTopRightControl("bringFwd", 0, iconStackUp, (obj) => {
        const cur = obj.canvas.getObjects().indexOf(obj);
        const maxIdx = self._topCeilingIndex();
        if (cur < maxIdx) obj.canvas.bringForward(obj);
      });

      makeTopRightControl("sendBack", 1, iconStackDown, (obj) => {
        const cur = obj.canvas.getObjects().indexOf(obj);
        const minIdx = self._bgTopIndex() + 1;
        if (cur > minIdx) obj.canvas.sendBackwards(obj);
      });

      const ROTATE_SIZE = 26;
      const ROTATE_OFFSETY = -32;

      fabric.Object.prototype.controls.mtr = new fabric.Control({
        x: 0,
        y: -0.5,
        offsetY: ROTATE_OFFSETY,
        cornerSize: ROTATE_SIZE,
        cursorStyleHandler: fabric.controlsUtils.rotationStyleHandler,
        actionHandler: fabric.controlsUtils.rotationWithSnapping,
        actionName: "rotate",
        render: renderIcon(iconRotate),
        withConnection: true,
        connectionStyle: { stroke: "#000", strokeWidth: 1 },
      });
    }

    handleResize() {
      if (!this.canvas) return;
      this.updateCanvasSize();
      this.drawClipPath();
      this.canvas.renderAll();
    }

    updateCanvasSize() {
      const container = document.getElementById("canvasContainer");
      if (!container || !this.canvas) return;

      const width = Math.max(1, container.clientWidth || 1);
      const small = window.matchMedia("(max-width: 640px)").matches;

      const { width: wIn, height: hIn } = this.parseSize(state.size);
      const ratio = wIn / hIn;

      let height;

      if (small) {
        let base = Math.max(120, Math.round(width / ratio));
        const nearSquare = ratio >= 0.9 && ratio <= 1.1;
        const midSquare = ratio > 0.75 && ratio < 1.33;
        const shrink = nearSquare ? 0.82 : (midSquare ? 0.9 : 1);
        height = Math.round(base * shrink);
        const maxVH = Math.floor(window.innerHeight * 0.6);
        height = Math.min(height, maxVH);
      } else {
        height = Math.max(1, container.clientHeight || Math.round(width / ratio));
      }

      this.canvas.setDimensions({ width, height });
      this.canvas.calcOffset();
      this.canvas.renderAll();
    }
    
    parseSize(sizeStr) {
      if (!sizeStr) {
        console.warn("Size string is undefined, using default 4'x1'");
        sizeStr = "4'x1'";
      }
      const [width, height] = sizeStr
        .replace("'", "")
        .split("x")
        .map((val) => parseFloat(val) * 12);
      return { width, height };
    }

    mobileFillForRatio(ratio) {
      if (ratio >= 0.9 && ratio <= 1.1) return 0.88;
      if (ratio >= 1.6 || ratio <= 0.625) return 0.95;
      return 0.90;
    }
    
    // New method to check if any content is present
    hasContent() {
      return (
        (state.color && state.color !== "None") ||
        (state.premium_backgrounds && state.premium_backgrounds !== "None") ||
        this.uploadedImage1 ||
        this.uploadedImage2 ||
        (state.text1 && state.text1.trim()) ||
        (state.text2 && state.text2.trim())
      );
    }

    // New method to update the finishEditing button state
    updateFinishButtonState() {
      const finishEditing = document.getElementById("finishEditing");
      if (finishEditing) {
        finishEditing.disabled = !this.hasContent();
      }
    }

    drawClipPath() {
      if (!this.canvas) return;

      const objects = [
        this.uploadedImage1,
        this.uploadedImage2,
        this.text1,
        this.text2,
      ].filter(Boolean);

      let oldWidth = 0, oldHeight = 0, oldLeft = 0, oldTop = 0;
      if (this.clipPath) {
        oldWidth = this.clipPath.width;
        oldHeight = this.clipPath.height;
        oldLeft = this.clipPath.left;
        oldTop = this.clipPath.top;
      }

      this.canvas.clear();
      this.canvas.clipPath = null;

      const parsedSize = this.parseSize(state.size);
      const ratio = parsedSize.width / parsedSize.height;
      const small = window.matchMedia("(max-width: 640px)").matches;
      const fill = small ? this.mobileFillForRatio(ratio) : 0.8;
      const maxWidth = this.canvas.getWidth() * fill;
      const maxHeight = this.canvas.getHeight() * fill;
      let clipWidth, clipHeight;
      if (ratio > maxWidth / maxHeight) {
        clipWidth = maxWidth;
        clipHeight = maxWidth / ratio;
      } else {
        clipHeight = maxHeight;
        clipWidth = maxHeight * ratio;
      }
      const centerX = this.canvas.getWidth() / 2;
      const centerY = this.canvas.getHeight() / 2;

      this.backgroundRect = new fabric.Rect({
        left: centerX - clipWidth / 2,
        top: centerY - clipHeight / 2,
        width: clipWidth,
        height: clipHeight,
        fill: COLOR_MAPPINGS[state.color] || "transparent",
        selectable: false,
        evented: false,
      });
      this.canvas.add(this.backgroundRect);

      this.clipPath = new fabric.Rect({
        left: centerX - clipWidth / 2,
        top: centerY - clipHeight / 2,
        width: clipWidth,
        height: clipHeight,
        absolutePositioned: true,
      });
      this.canvas.clipPath = this.clipPath;

      if (state.premium_backgrounds !== "None") {
        const url = PREMIUM_BACKGROUND_URLS[state.premium_backgrounds];
        if (url) {
          fabric.Image.fromURL(
            url,
            (img) => {
              if (!this.canvas || !this.clipPath) return;
              if (this.backgroundImage) this.canvas.remove(this.backgroundImage);
              const scale = Math.max(
                clipWidth / img.width,
                clipHeight / img.height
              );
              img.set({
                scaleX: scale,
                scaleY: scale,
                originX: "center",
                originY: "center",
                left: centerX,
                top: centerY,
                selectable: false,
                evented: false,
              });
              this.canvas.add(img);
              this.backgroundImage = img;
              this.canvas.sendToBack(this.backgroundImage);
              if (this.backgroundRect) this.canvas.sendBackwards(this.backgroundRect);
              this.canvas.renderAll();
              this.updateFinishButtonState();
            },
            { crossOrigin: "anonymous" }
          );
        }
      }

      const hasOld = oldWidth > 0 && oldHeight > 0;
      const scaleFactor = hasOld ? (clipWidth / oldWidth) : 1;
      objects.forEach((obj) => {
        this.canvas.add(obj);
        if (hasOld) {
          const relX = (obj.left - oldLeft) / oldWidth;
          const relY = (obj.top - oldTop) / oldHeight;
          obj.set({
            left: centerX - clipWidth / 2 + relX * clipWidth,
            top: centerY - clipHeight / 2 + relY * clipHeight,
            scaleX: obj.scaleX * scaleFactor,
            scaleY: obj.scaleY * scaleFactor,
          });
        } else {
          obj.set({
            left: centerX,
            top: centerY,
            originX: obj.originX || "center",
            originY: obj.originY || "center",
          });
        }
        obj.setCoords();
      });

      this.guidelineObjects.forEach((o) => this.canvas.remove(o));
      this.guidelineObjects = [];
      const showGuidelines = document.getElementById("toggleGuides")?.checked || false;
      if (showGuidelines) {
        const guide = new fabric.Rect({
          left: centerX - (clipWidth - 20) / 2,
          top: centerY - (clipHeight - 20) / 2,
          width: clipWidth - 20,
          height: clipHeight - 20,
          fill: "transparent",
          stroke: "#ec008c",
          strokeWidth: 1,
          strokeDashArray: [6, 3],
          selectable: false,
          evented: false,
        });
        this.canvas.add(guide);
        this.guidelineObjects.push(guide);
      }

      if (this.backgroundImage) this.canvas.sendToBack(this.backgroundImage);
      if (this.backgroundRect) this.canvas.sendToBack(this.backgroundRect);
      this.guidelineObjects.forEach((g) => this.canvas.bringToFront(g));
      this.canvas.renderAll();
    }

    toggleGuidelines(visible) {
      if (!this.canvas) return;
      this.guidelineObjects.forEach((obj) => obj.visible = visible);
      if (visible) this._bringGuidesToFront();
      this.canvas.renderAll();
    }

    alignObjects(direction) {
      if (!this.canvas || !this.clipPath) return;
      const activeObjects = this.canvas.getActiveObjects();
      if (!activeObjects.length) return;
      if (activeObjects.length === 1) {
        const bounds = this.clipPath.getBoundingRect(true);
        activeObjects.forEach((obj) => {
          switch (direction) {
            case "left":
              obj.set({ left: bounds.left + obj.getScaledWidth() / 2 });
              break;
            case "centerH":
              obj.set({ left: bounds.left + bounds.width / 2 });
              break;
            case "right":
              obj.set({
                left: bounds.left + bounds.width - obj.getScaledWidth() / 2,
              });
              break;
            case "top":
              obj.set({ top: bounds.top + obj.getScaledHeight() / 2 });
              break;
            case "centerV":
              obj.set({ top: bounds.top + bounds.height / 2 });
              break;
            case "bottom":
              obj.set({
                top: bounds.top + bounds.height - obj.getScaledHeight() / 2,
              });
              break;
          }
          obj.setCoords();
        });
      } else {
        let minLeft = Infinity,
          maxRight = -Infinity,
          minTop = Infinity,
          maxBottom = -Infinity;
        let totalCenterX = 0,
          totalCenterY = 0;
        activeObjects.forEach((obj) => {
          const bound = obj.getBoundingRect(true);
          minLeft = Math.min(minLeft, bound.left);
          maxRight = Math.max(maxRight, bound.left + bound.width);
          minTop = Math.min(minTop, bound.top);
          maxBottom = Math.max(maxBottom, bound.top + bound.height);
          totalCenterX += bound.left + bound.width / 2;
          totalCenterY += bound.top + bound.height / 2;
        });
        const avgCenterX = totalCenterX / activeObjects.length;
        const avgCenterY = totalCenterY / activeObjects.length;
        activeObjects.forEach((obj) => {
          switch (direction) {
            case "left":
              obj.set({ left: minLeft + obj.getScaledWidth() / 2 });
              break;
            case "centerH":
              obj.set({ left: avgCenterX });
              break;
            case "right":
              obj.set({ left: maxRight - obj.getScaledWidth() / 2 });
              break;
            case "top":
              obj.set({ top: minTop + obj.getScaledHeight() / 2 });
              break;
            case "centerV":
              obj.set({ top: avgCenterY });
              break;
            case "bottom":
              obj.set({ top: maxBottom - obj.getScaledHeight() / 2 });
              break;
          }
          obj.setCoords();
        });
      }
      this.canvas.renderAll();
    }

    updateBackgroundColor(color) {
      state.color = color;
      if (this.backgroundRect) {
        this.backgroundRect.set({
          fill: COLOR_MAPPINGS[color] || "transparent",
        });
        this.canvas.sendToBack(this.backgroundRect);
        if (this.backgroundImage) {
          this.canvas.sendToBack(this.backgroundImage);
          this.canvas.sendBackwards(this.backgroundRect);
        }
        this.canvas.renderAll();
      } else {
        this.drawClipPath();
      }
      this.updateFinishButtonState();
    }

    updatePremiumBackground(backgroundName) {
      if (!this.canvas || !this.clipPath) {
        this.drawClipPath();
      }
      state.premium_backgrounds = backgroundName;
      if (backgroundName === "None") {
        if (this.backgroundImage) {
          this.canvas.remove(this.backgroundImage);
          this.backgroundImage = null;
        }
        this.canvas.renderAll();
        this.updateFinishButtonState();
        return;
      }
      const url = PREMIUM_BACKGROUND_URLS[backgroundName];
      if (!url) {
        this.showError("Invalid premium background selected.");
        return;
      }
      fabric.Image.fromURL(
        url,
        (img) => {
          if (!this.canvas || !this.clipPath) {
            return;
          }
          if (this.backgroundImage) this.canvas.remove(this.backgroundImage);
          const centerX = this.canvas.getWidth() / 2;
          const centerY = this.canvas.getHeight() / 2;
          const clipWidth = this.clipPath.width;
          const clipHeight = this.clipPath.height;
          const scale = Math.max(
            clipWidth / img.width,
            clipHeight / img.height
          );
          img.set({
            scaleX: scale,
            scaleY: scale,
            originX: "center",
            originY: "center",
            left: centerX,
            top: centerY,
            selectable: false,
            evented: false,
          });
          this.canvas.add(img);
          this.backgroundImage = img;
          this.canvas.sendToBack(this.backgroundImage);
          this.canvas.sendBackwards(this.backgroundRect);
          this.canvas.renderAll();
          this.updateFinishButtonState();
        },
        { crossOrigin: "anonymous" }
      );
    }

    updateSize(size) {
      if (!size) {
        console.warn("Size is undefined, using default 4'x1'");
        size = "4'x1'";
      }
      state.size = size;
      this.updateCanvasSize();
      this.drawClipPath();
      updatePreviewSizeDisplay(size);
      if (state.editedImage) {
        window.clearTimeout(this._previewRefreshTimer);
        this._previewRefreshTimer = window.setTimeout(() => {
          this.refreshEditedPreviewForCurrentSize();
        }, 80);
      }
      recalcPrice();
    }

    async refreshEditedPreviewForCurrentSize() {
      if (!this.canvas || !this.clipPath || !state.editedImage) return;
      const hideList = [];
      if (this.guidelineObjects) {
        this.guidelineObjects.forEach((g) => {
          hideList.push(g);
          g.visible = false;
        });
      }
      if (this.backgroundImage) this.canvas.sendToBack(this.backgroundImage);
      if (this.backgroundRect) this.canvas.sendToBack(this.backgroundRect);
      this.canvas.renderAll();
      try {
        const bounds = this.clipPath.getBoundingRect(true);
        const dataURL = this.canvas.toDataURL({
          left: bounds.left,
          top: bounds.top,
          width: bounds.width,
          height: bounds.height,
          format: "png",
          multiplier: 2,
          enableRetinaScaling: true,
        });
        const blob = await (await fetch(dataURL)).blob();
        state.editedImage = new File([blob], "edited-banner.png", {
          type: "image/png",
        });
        updateAddToCartAvailability();
        const previewImage = document.getElementById("preview-image");
        if (previewImage) previewImage.src = dataURL;
        updatePreviewSizeDisplay();
      } catch (err) {
        console.error("Error refreshing edited preview:", err);
      } finally {
        hideList.forEach((obj) => {
          obj.visible = document.getElementById("toggleGuides")?.checked || false;
        });
        this.canvas.renderAll();
      }
    }

    handleImageUpload1(event) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
        "image/svg+xml",
        "application/pdf",
        "image/tiff",
        "application/postscript",
      ];
      if (
        !allowedTypes.includes(file.type) &&
        !file.name.match(/\.(ai|eps)$/i)
      ) {
        this.showError(
          "Please upload a valid image file (.ai, .eps, .jpg, .png, .pdf, .tiff, .svg, .webp)"
        );
        return;
      }
      if (!this.canvas || !this.clipPath) {
        this.drawClipPath();
      }
      fabric.Image.fromURL(
        URL.createObjectURL(file),
        (img) => {
          if (!this.canvas || !this.clipPath) {
            return;
          }
          if (this.uploadedImage1) this.canvas.remove(this.uploadedImage1);
          const clipWidth = this.clipPath.width;
          const clipHeight = this.clipPath.height;
          const scaleFactor = Math.min(
            (clipWidth * 0.5) / img.width,
            (clipHeight * 0.5) / img.height
          );
          const centerX = this.canvas.getWidth() / 2;
          const centerY = this.canvas.getHeight() / 2;
          img.set({
            scaleX: scaleFactor,
            scaleY: scaleFactor,
            originX: "center",
            originY: "center",
            left: centerX - clipWidth / 4,
            top: centerY,
            selectable: true,
            evented: true,
            hasControls: true,
            hasBorders: true,
            lockMovementX: false,
            lockMovementY: false,
            lockScalingX: false,
            lockScalingY: false,
          });
          img.setCoords();
          this.canvas.add(img);
          this.uploadedImage1 = img;
          this.canvas.renderAll();
          this.updateFinishButtonState();
          state.uploadedImage1 = file;
        },
        { crossOrigin: "anonymous" }
      );
      state.uploadedImage1 = file;
      console.log(state.uploadedImage1);
    }

    handleImageUpload2(event) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/svg+xml",
        "application/pdf",
        "image/tiff",
        "application/postscript",
      ];
      if (
        !allowedTypes.includes(file.type) &&
        !file.name.match(/\.(ai|eps)$/i)
      ) {
        this.showError(
          "Please upload a valid image file (.ai, .eps, .jpg, .png, .pdf, .tiff, .svg)"
        );
        return;
      }
      if (!this.canvas || !this.clipPath) {
        this.drawClipPath();
      }
      fabric.Image.fromURL(
        URL.createObjectURL(file),
        (img) => {
          if (!this.canvas || !this.clipPath) {
            return;
          }
          if (this.uploadedImage2) this.canvas.remove(this.uploadedImage2);
          const clipWidth = this.clipPath.width;
          const clipHeight = this.clipPath.height;
          const scaleFactor = Math.min(
            (clipWidth * 0.5) / img.width,
            (clipHeight * 0.5) / img.height
          );
          const centerX = this.canvas.getWidth() / 2;
          const centerY = this.canvas.getHeight() / 2;
          img.set({
            scaleX: scaleFactor,
            scaleY: scaleFactor,
            originX: "center",
            originY: "center",
            left: centerX + clipWidth / 4,
            top: centerY,
            selectable: true,
            evented: true,
            hasControls: true,
            hasBorders: true,
            lockMovementX: false,
            lockMovementY: false,
            lockScalingX: false,
            lockScalingY: false,
          });
          img.setCoords();
          this.canvas.add(img);
          this.uploadedImage2 = img;
          this.canvas.renderAll();
          this.updateFinishButtonState();
          state.uploadedImage2 = file;
        },
        { crossOrigin: "anonymous" }
      );
      state.uploadedImage2 = file;
    }

    updateText1(text) {
      if (!this.canvas || !this.clipPath) {
        this.drawClipPath();
      }
      const currentPosition = this.text1
        ? { left: this.text1.left, top: this.text1.top }
        : null;
      const currentFont = this.text1
        ? this.text1.fontFamily
        : state.font1.replaceAll(" ", "") || "Arial";
      const currentColor = this.text1
        ? this.text1.fill
        : FONT_COLORS[state.font_color1] || "Black";

      if (this.text1) this.canvas.remove(this.text1);
      state.text1 = text;

      if (text.trim()) {
        const clipWidth = this.clipPath.width;
        const textObj = new fabric.Text(text, {
          fontFamily: currentFont,
          fill: currentColor,
          originX: "center",
          originY: "center",
          left: currentPosition
            ? currentPosition.left
            : this.canvas.getWidth() / 2,
          top: currentPosition
            ? currentPosition.top
            : this.canvas.getHeight() / 2,
          fontSize: 40,
          lineHeight: 1,
          selectable: true,
          evented: true,
          textBaseline: "alphabetic",
          editable: false,
        });

        const textWidth = textObj.getScaledWidth();
        if (textWidth > clipWidth * 0.8) {
          const scale = (clipWidth * 0.8) / textWidth;
          textObj.set('scaleX', scale);
          textObj.set('scaleY', scale);
        }

        textObj.setCoords();
        this.canvas.add(textObj);
        this.text1 = textObj;
        this.canvas.renderAll();
      } else {
        this.text1 = null;
        this.canvas.renderAll();
      }
      this.updateFinishButtonState();
    }

    updateText2(text) {
      if (!this.canvas || !this.clipPath) {
        this.drawClipPath();
      }
      const currentPosition = this.text2
        ? { left: this.text2.left, top: this.text2.top }
        : null;
      const currentFont = this.text2
        ? this.text2.fontFamily
        : state.font2.replaceAll(" ", "") || "Arial";
      const currentColor = this.text2
        ? this.text2.fill
        : FONT_COLORS[state.font_color2] || "Black";

      if (this.text2) this.canvas.remove(this.text2);
      state.text2 = text;

      if (text.trim()) {
        const clipWidth = this.clipPath.width;
        const textObj = new fabric.Text(text, {
          fontFamily: currentFont,
          fill: currentColor,
          originX: "center",
          originY: "center",
          left: currentPosition
            ? currentPosition.left
            : this.canvas.getWidth() / 2,
          top: currentPosition
            ? currentPosition.top
            : this.canvas.getHeight() / 2,
          fontSize: 40,
          lineHeight: 1,
          selectable: true,
          evented: true,
          textBaseline: "alphabetic",
          editable: false,
        });

        const textWidth = textObj.getScaledWidth();
        if (textWidth > clipWidth * 0.8) {
          const scale = (clipWidth * 0.8) / textWidth;
          textObj.set('scaleX', scale);
          textObj.set('scaleY', scale);
        }

        textObj.setCoords();
        this.canvas.add(textObj);
        this.text2 = textObj;
        this.canvas.renderAll();
      } else {
        this.text2 = null;
        this.canvas.renderAll();
      }
      this.updateFinishButtonState();
    }

    updateFont1(font) {
      if (!font) {
        console.warn("Font is undefined, using default Arial");
        font = "Arial";
      }
      state.font1 = font;
      if (this.text1) {
        if (font == "3rd Rail") {
          this.text1.set("fontFamily", "Third_Rail");
        } else {
          this.text1.set("fontFamily", font.replaceAll(" ", ""));
        }
        this.canvas.renderAll();
      }
    }

    updateFont2(font) {
      if (!font) {
        console.warn("Font is undefined, using default Arial");
        font = "Arial";
      }
      state.font2 = font;
      if (this.text2) {
        if (font == "3rd Rail") {
          this.text2.set("fontFamily", "Third_Rail");
        } else {
          this.text2.set("fontFamily", font.replaceAll(" ", ""));
        }
        this.canvas.renderAll();
      }
    }

    updateFontColor1(color) {
      if (!color) return;
      state.font_color1 = color;
      if (this.text1) {
        this.text1.set("fill", FONT_COLORS[color]);
        console.log("Font Color: ", FONT_COLORS[color]);
        this.canvas.renderAll();
      }
    }

    updateFontColor2(color) {
      if (!color) return;
      state.font_color2 = color;
      if (this.text2) {
        this.text2.set("fill", FONT_COLORS[color]);
        this.canvas.renderAll();
      }
    }

    async finishEditing() {
      if (!this.canvas || !this.clipPath) {
        this.showError("Please create a design before finishing.");
        return;
      }
      if (!this.hasContent()) {
        this.showError("Please add a background, image, or text before finishing.");
        return;
      }
      const hideList = [];
      if (this.guidelineObjects) {
        this.guidelineObjects.forEach((g) => {
          hideList.push(g);
          g.visible = false;
        });
      }
      if (this.backgroundImage) this.canvas.sendToBack(this.backgroundImage);
      if (this.backgroundRect) this.canvas.sendToBack(this.backgroundRect);
      this.canvas.renderAll();
      try {
        const bounds = this.clipPath.getBoundingRect(true);
        const dataURL = this.canvas.toDataURL({
          left: bounds.left,
          top: bounds.top,
          width: bounds.width,
          height: bounds.height,
          format: "png",
          multiplier: 2,
          enableRetinaScaling: true
        });
        const blob = await (await fetch(dataURL)).blob();
        state.editedImage = new File([blob], "edited-banner.png", { type: "image/png" });
        updateAddToCartAvailability();
        console.log("Edited Image File:", state.editedImage, state.editedImage.size, state.editedImage.type);
        const previewImage = document.getElementById("preview-image");
        if (previewImage) {
          previewImage.src = dataURL;
        }
        const designerTool = document.getElementById("designerTool");
        const previewBox = document.getElementById("preview-box");
        const mainVariants = document.getElementById("main-variants");
        const uploadArtbox = document.getElementById("upload-artbox");
        const sizeSelectMain = document.getElementById("size-select-variant-main");

        if (designerTool) {
          designerTool.classList.remove("active");
          enableBodyScroll();
        }
        if (previewBox) {
          previewBox.style.display = "block";
          // Ensure non-editable class is only applied for non-editable artwork uploads
          if (state.artworkImage && isDisplayableImage(state.artworkImage)) {
            previewBox.classList.add("non-editable-image");
          } else {
            previewBox.classList.remove("non-editable-image");
          }
        }
        if (mainVariants) {
          // Show main-variants if there is an artwork or edited image
          if (state.artworkImage || state.editedImage) {
            mainVariants.classList.add("active");
          } else {
            mainVariants.classList.remove("active");
          }
        }
        if (uploadArtbox) uploadArtbox.style.display = "none";
        updatePreviewSizeDisplay();
      } catch (err) {
        console.error("Error saving edited image:", err);
        this.showError("Failed to save edited image. Please try again.");
      } finally {
        hideList.forEach((obj) => (obj.visible = document.getElementById("toggleGuides")?.checked || false));
        this.canvas.renderAll();
      }
    }

    handleRemoveAll() {
      if (this.canvas) {
        this.canvas.clear();
        this.canvas.clipPath = null;
        this.canvas.dispose();
      }
      this.clipPath = null;
      this.backgroundRect = null;
      this.backgroundImage = null;
      this.uploadedImage1 = null;
      this.uploadedImage2 = null;
      this.text1 = null;
      this.text2 = null;
      this.guidelineObjects = [];
      state.uploadedImage1 = null;
      state.uploadedImage2 = null;
      state.editedImage = null;
      state.artworkImage = null;
      updateAddToCartAvailability();
      state.text1 = "";
      state.text2 = "";
      state.premium_backgrounds = "None";
      state.color = "None";
      ["upload-file1", "upload-file2"].forEach((id) => {
        const artbox = document.getElementById(`upload-artbox${id.slice(-1)}`);
        const previewBox = document.getElementById(`preview-box${id.slice(-1)}`);
        if (artbox) artbox.style.display = "block";
        if (previewBox) previewBox.style.display = "none";
      });
      const textInput1 = document.getElementById("text-input-1");
      const textInput2 = document.getElementById("text-input-2");
      if (textInput1) textInput1.value = "";
      if (textInput2) textInput2.value = "";
      const designerTool = document.getElementById("designerTool");
      if (designerTool) {
        designerTool.classList.remove("active");
        enableBodyScroll();
      }
      const mainVariants = document.getElementById("main-variants");
      const sizeSelectMain = document.getElementById("size-select-variant-main");
      if (mainVariants) mainVariants.classList.remove("active");
      if (sizeSelectMain) sizeSelectMain.classList.remove("active");
      this.init();
      this.updateFinishButtonState();
    }

    showError(message) {
      const msgEl = document.getElementById("canvasMessage");
      if (msgEl) {
        msgEl.classList.remove("warning");
        msgEl.classList.add("error");
        msgEl.textContent = message;
        show(msgEl);
        setTimeout(() => hide(msgEl), 5000);
      }
    }
    
    showWarning(message) {
      const msgEl = document.getElementById("canvasMessage");
      if (msgEl) {
        msgEl.classList.remove("error");
        msgEl.classList.add("warning");
        msgEl.textContent = message;
        show(msgEl);
        setTimeout(() => hide(msgEl), 5000);
      }
    }
  }
  // =============================================
  // 24. INITIALIZE EVERYTHING
  // =============================================
  function hydrateCompactMarkup() {
    const copyDropdownOptions = (sourceId, targetId) => {
      const source = document.querySelector(`#${sourceId} .dropdown-options`);
      const target = document.querySelector(`#${targetId} .dropdown-options`);
      if (!source || !target || target.children.length > 1) return;
      target.innerHTML = source.innerHTML;
    };

    copyDropdownOptions("size-select", "size-select-main");
    copyDropdownOptions("font1-select", "font2-select");

    const sourceSwatches = document.querySelector(
      "#text-color-variant1 .letter-color-variants__list"
    );
    const targetSwatches = document.querySelector(
      "#text-color-variant2 .letter-color-variants__list"
    );
    if (sourceSwatches && targetSwatches && !targetSwatches.children.length) {
      targetSwatches.innerHTML = sourceSwatches.innerHTML;
    }
  }

  function initialize() {
    hydrateCompactMarkup();
    // Dynamically add the snapping toggle to inline-actions (reuse guides styles)
    const inlineActions = document.querySelector(".inline-actions");
    if (inlineActions) {
      const snapToggle = document.createElement("label");
      snapToggle.className = "guides-toggle-switch";
      snapToggle.innerHTML = `
        <input type="checkbox" id="toggleSnap" checked />
        <span class="guides-slider"></span>
        <span class="guides-label-text">Snapping</span>
      `;
      inlineActions.appendChild(snapToggle);
    }
    designer = new BannerDesigner();
    setupImageUpload(
      "upload-file1",
      "preview-box1",
      "preview-image1",
      "upload-file-error1",
      "uploadedImage1"
    );
    setupImageUpload(
      "upload-file2",
      "preview-box2",
      "preview-image2",
      "upload-file-error2",
      "uploadedImage2"
    );
    setupSizeSelectorSynchronization();
    setupArtworkUpload();
    initDropdownDefaults();
    setupTextColor1Selection();
    setupTextColor2Selection();
    setupMainColorSelection();
    handleTextInput1();
    handleTextInput2();
    handleDesignNotesInput();
    setupGrommetSelection();
    setupGrommetColorSelection();
    setupPackagingTypeSelection();
    setupApippaAddToCart();
    document.addEventListener("click", dropdownClickHandler);
    recalcPrice();
  }
  initialize();
});
